/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOut } from './CarveOut';
import {
    CarveOutFromJSON,
    CarveOutFromJSONTyped,
    CarveOutToJSON,
    CarveOutToJSONTyped,
} from './CarveOut';

/**
 * 
 * @export
 * @interface CreateCarveOut201Response
 */
export interface CreateCarveOut201Response {
    /**
     * 
     */
    data?: CarveOut;
}

/**
 * Check if a given object implements the CreateCarveOut201Response interface.
 */
export function instanceOfCreateCarveOut201Response(value: object): value is CreateCarveOut201Response {
    return true;
}

export function CreateCarveOut201ResponseFromJSON(json: any): CreateCarveOut201Response {
    return CreateCarveOut201ResponseFromJSONTyped(json, false);
}

export function CreateCarveOut201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCarveOut201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CarveOutFromJSON(json['data']),
    };
}

export function CreateCarveOut201ResponseToJSON(json: any): CreateCarveOut201Response {
    return CreateCarveOut201ResponseToJSONTyped(json, false);
}

export function CreateCarveOut201ResponseToJSONTyped(value?: CreateCarveOut201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CarveOutToJSON(value['data']),
    };
}

